module.exports = __webpack_public_path__ + "img/cover-turkcell-foursquare-launch.176293ae.jpg";